import store from '@/redux/store';
import { authActions } from '@/redux/auth/authSlice';
import { clearAllAudienceCaches, clearAuthStorage, logoutAccounts } from './auth';

export const SCULPX_USER_SWITCH_KEY = 'sculpx_user_switch';

export function decodeJwtSub(token: string): string | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = JSON.parse(atob(payload)) as { sub?: unknown };
    const sub = json?.sub;
    return typeof sub === 'string' ? sub : sub != null ? String(sub) : null;
  } catch { return null; }
}

export function getStoredCalendarUserId(): string | null {
  try {
    const raw = sessionStorage.getItem('user');
    if (!raw) return null;
    const u = JSON.parse(raw) as { id?: unknown };
    return u?.id != null ? String(u.id) : null;
  } catch { return null; }
}

export function broadcastUserSwitchToSiblings(): void {
  try { localStorage.setItem(SCULPX_USER_SWITCH_KEY, String(Date.now())); }
  catch { /* ignore */ }
}

export async function applyUserSwitchIfMismatch(
  incomingUserId: string | null,
  oldAccessToken: string | null
): Promise<boolean> {
  if (!incomingUserId) return false;
  const current = getStoredCalendarUserId();
  if (!current || current === incomingUserId) return false;

  await logoutAccounts(oldAccessToken);
  clearAllAudienceCaches();
  clearAuthStorage();
  store.dispatch(authActions.clearAuth());
  broadcastUserSwitchToSiblings();
  return true;
}
